export enum ScrollLockClass {
  IS_CLIPPED = 'is-clipped'
}
